import React , { Component, Fragment } from 'react'
import AttendanceTable from './AttendaceTable'
import { Input , Form, Row,Col, Select , Button , message, TimePicker} from 'antd'
import Axios from 'axios'
import keys from '../../keys'
import { connect } from 'react-redux'




class AddAttendance extends Component{
    state ={
        NIC: "" ,
        attendance_type: "",
       
    }

    onChange = (event) =>{
        this.setState(
            {
                NIC: event.target.value
            }
        )
    }

    handleSelectChange = (value) =>{
        this.setState({
            attendance_type:value
        })
    }

    onTimeChange = time => {
       
        this.setState({time:time})
    }

    handleSubmit = (event) =>{
        event.preventDefault()
       
        if (this.state.time){

        if (this.state.attendance_type === "CHECKIN" || this.state.attendance_type === "CHECKOUT" ){
            this.props.setLoading(true)
            console.log(this.state.time.format())
            Axios.post(
                `${this.props.server}/hr/mark-attendance/` , {...this.state , time:this.state.time.format()}
            )
            .then(
                result =>{
                    if(result.data.success){
                        message.success("Attendance Created! " + result.data.message)
                        this.props.setLoading(false)
                        
                    }else{
                        message.error("Opps! " + result.data.message)
                        this.props.setLoading(false)
                    }     
                }
            )
        }else{
            message.error("Please select an attenace type")
            this.props.setLoading(false)
        }
        }else{
            message.error("Oops! Attendance time is not set")
        }
        
    }

    render(){
        return( 
        <Fragment>
            <Form onSubmit={this.handleSubmit}>     
                    <Row gutter={10}>
                        <Col span={4}>
                            <Form.Item label = "NIC"> 
                                <Input required onChange={this.onChange}></Input>
                            </Form.Item> 
                        </Col> 
                        <Col span={4}> 
                        <Form.Item label = "Attendance Type">                      
                                <Select  onChange={this.handleSelectChange}>
                                    <Select.Option value="CHECKIN"> CHECK-IN</Select.Option>
                                    <Select.Option value="CHECKOUT"> CHECK-OUT</Select.Option>
                                </Select>                
                        </Form.Item>
                        </Col>
                        <Col span={4}> 
                        <Form.Item label = "Time">                      
                                <TimePicker  value={this.state.time} onChange={this.onTimeChange}></TimePicker>              
                        </Form.Item>
                        </Col>
                        <Col span={3} style={{paddingTop:"43px"}}>
                            <Button style={{width:"200px"}} htmlType="submit" type="primary" >Add</Button>     
                        </Col>                         
                    </Row>                          
            </Form>
        </Fragment>
        )
    }

}

const mapStateToProps = state => ({
    server : state.entity.server
})



export default connect(mapStateToProps,null)(AddAttendance)